import React from 'react';
import { PageProps } from 'gatsby';
import { ThemeProvider } from '@material-tailwind/react';
import { QueryParamProvider } from 'use-query-params';
import { ReachAdapter } from 'use-query-params/adapters/reach';

import type { PageContext } from '@models';
import { PageProvider } from '@context/pageProvider';

export type Context<STATE, ACTIONS> = [ STATE, React.Dispatch<ACTIONS> ];

interface GlobalStateProviderProps {
    children: React.ReactElement<PageProps<any, PageContext>>;
}

export const GlobalStateProvider = ({ children }: GlobalStateProviderProps) => {
    const pageContext = children.props.pageContext;

    // Use a key based on page context to force remount on page navigation
    const contextKey = `${pageContext?.id || ''}-${pageContext?.locale || ''}-${pageContext?.slug || ''}`;

    return (
        <QueryParamProvider adapter={ ReachAdapter }>
            <PageProvider key={ contextKey } context={ pageContext }>
                <ThemeProvider>
                    { children }
                </ThemeProvider>
            </PageProvider>
        </QueryParamProvider>
    );
};
